import type { Invoice } from '@lombok/shared';
import { buildCsv, csvDate, csvMoney, csvText } from '@/lib/csv';
import { statusLabel } from '@/components/StatusPill';
import { invoiceKindLabel, invoiceNumberLabel } from './labels';

/**
 * CSV of the invoices on screen (the active status tab). Same es-VE Excel conventions as the
 * Reportes export (`@/lib/csv`). `customerName` swaps the account id for its name when known.
 */
export const INVOICES_CSV_HEADERS: readonly string[] = [
  'Factura',
  'Tipo',
  'Cliente',
  'Emisión',
  'Vence',
  'Total USD',
  'Pagado USD',
  'Saldo USD',
  'Estado',
];

export function invoicesToCsv(
  items: readonly Invoice[],
  customerName: (customerId: string) => string | undefined = () => undefined,
): string {
  return buildCsv(
    INVOICES_CSV_HEADERS,
    items.map((inv) => [
      invoiceNumberLabel(inv),
      invoiceKindLabel(inv.kind),
      csvText(customerName(inv.customerId) ?? inv.customerId),
      csvDate(inv.issueDate),
      csvDate(inv.dueDate),
      csvMoney(inv.totalMinorUsd),
      csvMoney(inv.paidMinorUsd),
      csvMoney(inv.balanceMinorUsd),
      statusLabel('invoice', inv.status),
    ]),
  );
}
